<template>
  <div class="w-100 pt3-ns pt2 ph3 pb5">
    <h1 class="bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 ml2-l mt3 mb0">{{ $t("app.latestNews") }}</h1>
    <div class="flex flex-wrap news-container w-100">
      <div v-show="loading" class="flex justify-center h5 w-100 mv3">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <carousel :per-page="1" paginationActiveColor="#E6007E" paginationColor="#ccc" :loop="true" ref="carousel"
        :autoplay="true" :autoplayTimeout="10000" class="w-75-ns w-100">
        <slide v-for="newsItem in news" :key="newsItem.id" class="news-container pl2-l pr2-ns pt2 w-100">
          <news class="h-100" :news="newsItem"/>
        </slide>
      </carousel>
      <div class="w-25 flex-ns dn flex-column">
        <div v-for="(newsItem, index) in news" :key="newsItem.id" class="image-container pt2">
          <div class="pointer dim h-100 relative hide-child cover center background-center flex items-end"
           :style="{'background-image': `url(${picture(newsItem)})`}" :class="{'selected': selected(index)}"
          @click="selectNews(index)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import consts from '@/consts'
import News from './News.vue'

export default {
  name: 'latest-news',
  data () {
    return {
      news: [],
      loading: true,
      latestNewsImg: String,
      latestNewsLoaded: false,
      selectedNews: {},
      color: '#808080',
      size: '30px'
    }
  },
  components: {
    FontAwesomeIcon,
    ClipLoader,
    News
  },
  created () {
    this.getNews()
      .then(response => {
        this.loading = false
        this.news = response.body.data
        this.selectedNews = response.body.data[0]
        this.latestNewsLoaded = true
      })
  },
  methods: {
    getNews () {
      return this.$http.get(`${consts.API_BASE_URL}/news/getHome`)
    },
    picture (news) {
      return consts.MEDIA_BASE_URL + news.path + news.image
    },
    selectNews (index) {
      this.$refs.carousel.goToPage(index)
    },
    selected (index) {
      return this.$refs.carousel.currentPage === index
    }
  }
}
</script>

<style lang="scss" scoped>
  .news-container {
    height: 570px;
  }
  .image-container {
    height: 190px;
  }
  .selected {
    opacity: .5;
  }

  @media (max-width: 479px) {
     .news-container {
      height: 350px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/LatestNews.vue